import apiClient from './client'

/**
 * Get the current user's subscription history
 * @returns {Promise<Array>} Array of subscription history records
 */
export const getUserSubscriptionHistory = async () => {
  try {
    const response = await apiClient.get(`/subscription-history/user/history`)
    return response.data
  } catch (error) {
    console.error('Error fetching user subscription history:', error)
    throw error
  }
}

/**
 * Get all subscription history records (admin only)
 * @param {string} userId - Optional user ID to filter by
 * @returns {Promise<Array>} Array of subscription history records
 */
export const getAllSubscriptionHistory = async (userId = null) => {
  try {
    const url = userId 
      ? `/subscription-history?userId=${userId}`
      : `/subscription-history`
    
    const response = await apiClient.get(url)
    return response.data
  } catch (error) {
    console.error('Error fetching all subscription history:', error)
    throw error
  }
}

/**
 * Get a specific subscription history record by ID
 * @param {string} id - Subscription history record ID
 * @returns {Promise<Object>} Subscription history record
 */
export const getSubscriptionHistoryById = async (id) => {
  try {
    const response = await apiClient.get(`/subscription-history/${id}`)
    return response.data
  } catch (error) {
    console.error(`Error fetching subscription history with ID ${id}:`, error)
    throw error
  }
}

/**
 * Update the credit used in a subscription history record (admin only)
 * @param {string} id - Subscription history record ID
 * @param {number} creditUsed - New credit used value
 * @returns {Promise<Object>} Updated subscription history record
 */
export const updateCreditUsed = async (id, creditUsed) => {
  try {
    const response = await apiClient.patch(
      `/subscription-history/${id}/credit-used`,
      { creditUsed }
    )
    return response.data
  } catch (error) {
    console.error(`Error updating credit used for subscription history ${id}:`, error)
    throw error
  }
}

/**
 * Create a new subscription history record (admin only)
 * @param {Object} data - Subscription history data
 * @returns {Promise<Object>} Created subscription history record
 */
export const createSubscriptionHistory = async (data) => {
  try {
    const response = await apiClient.post(`/subscription-history`, data)
    return response.data
  } catch (error) {
    console.error('Error creating subscription history:', error)
    throw error
  }
}

/**
 * Update a subscription history record (admin only)
 * @param {string} id - Subscription history record ID
 * @param {Object} data - Updated subscription history data
 * @returns {Promise<Object>} Updated subscription history record
 */
export const updateSubscriptionHistory = async (id, data) => {
  try {
    const response = await apiClient.patch(`/subscription-history/${id}`, data)
    return response.data
  } catch (error) {
    console.error(`Error updating subscription history ${id}:`, error)
    throw error
  }
}

/**
 * Delete a subscription history record (admin only)
 * @param {string} id - Subscription history record ID
 * @returns {Promise<void>}
 */
export const deleteSubscriptionHistory = async (id) => {
  try {
    await apiClient.delete(`/subscription-history/${id}`)
  } catch (error) {
    console.error(`Error deleting subscription history ${id}:`, error)
    throw error
  }
}
